import React, { useRef } from 'react';
import { Col, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import CandidateScheduleDateSelector from './CandidateScheduleDateSelector';
import { CustomButton, EvenRow } from './InterviewDateSelection.styles';
import Loading from 'Body/Statuses/Loading';

const InterviewDateSelection = (props) => {
  const syncFunctionRef = useRef(null); // Store the sync function
  const {
    hasPreferenceOrderWithNoInterviewDate,
    selectedDates,
    setSelectedDates,
    selectedableDates,
    setSelectedableDates,
    changeStep,
    singleDateChoice,
  } = props;

  // Handle sync function from CandidateScheduleDateSelector
  const handleSyncReady = (syncFunction) => {
    syncFunctionRef.current = syncFunction;
  };

  // Validate and navigate to next step
  const handleNext = (e) => {
    e.preventDefault();

    // Sync component state and get the actual selected dates
    if (syncFunctionRef.current) {
      const syncResult = syncFunctionRef.current();
      // Returns: { selectedDates: internalSelectedDates, selectedCount: internalSelectedDates.length }

      // Validate: Must have at least one date selected
      if (syncResult.selectedCount === 0) {
        Swal.fire('Oops...', 'Please select at least one interview date.', 'error');
        return; // Stop here, don't proceed
      }

      // Validation passed - proceed to confirmation page
      changeStep(e, 2);
    }
  };

  const combined = selectedDates.concat(selectedableDates);

  if (!combined || combined.length === 0) {
    return (
      <div style={{ color: '#000000' }}>
        {/* <FontAwesomeIcon icon={faSpinner} spin size="4x" /> */}

        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div style={{ width: 100, height: 100, display: 'flex' }}>
            {' '}
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Col stlye={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
      <Row>
        <CandidateScheduleDateSelector
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          selectedableDates={selectedableDates}
          setSelectedableDates={setSelectedableDates}
          singleDateChoice={singleDateChoice}
          isOrdinal={true}
          hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
          onSyncReady={handleSyncReady}
        />
      </Row>
      <EvenRow>
        <CustomButton color="danger" onClick={(e) => changeStep(e, 0)}>
          Decline
        </CustomButton>
        <CustomButton color="success" onClick={handleNext}>
          Next
        </CustomButton>
      </EvenRow>
    </Col>
  );
};

export default InterviewDateSelection;
